import { handleActions } from 'redux-actions';

import { shiftsSuccess } from './actions';
import { logoutSuccess } from 'ducks/auth/actions';
import initialState from './states';

export default handleActions(
  {
    [shiftsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
